<div class="container">
  <div class="sidebar">
    <div class="logo">
      <img
        class="logo-desktop"
        [routerLink]="['/']"
        routerLinkActive="router-link-active"
        src="assets/icons/tc_logo.svg"
        alt="tienda-do"
      />
      <div
        class="button-menu"
        (click)="showMenuMobile = !showMenuMobile; showOptions = false"
        [class.active]="showMenuMobile === true"
      >
        <span class="top"></span>
        <span class="mid"></span>
        <span class="bot"></span>
      </div>
    </div>

    <div class="sidebar-content" [class.show]="showMenuMobile">
      <div class="user">
        <img
          (click)="showOptionsClick()"
          class="profile-picture"
          [src]="
            authService?.loggedUser?.flags?.clubMember
              ? 'assets/icons/club-user.svg'
              : 'assets/icons/user.svg'
          "
          alt="profile-picture"
        />
        <div class="user-info" [class.showOptions]="showOptions">
          <div class="name" (click)="showOptionsClick()">
            <p *ngIf="authService.loggedUser">
              {{ showUserName().toLowerCase() }}
            </p>
            <p *ngIf="!authService.loggedUser">Invitado</p>
            <span *ngIf="!showOptions && authService.loggedUser">
              <img src="/assets/icons/news/arrow-down.svg" alt="arrow-down" />
            </span>
            <span *ngIf="showOptions">
              <img src="/assets/icons/news/arrow-up.svg" alt="arrow-up" />
            </span>
          </div>
          <div class="email" *ngIf="authService.loggedUser">
            <p *ngIf="!authService.loggedUser.isBanned && authService.loggedUser.cuit?.length >= 6">
              CUIT: {{ authService.loggedUser.cuit | slice : 0 : 2 }}-{{
                authService.loggedUser.cuit | slice : 2 : 10
              }}-{{ authService.loggedUser.cuit | slice : -1 }}
            </p>
            <p *ngIf="!authService.loggedUser.isBanned && authService.loggedUser.cuit?.length < 6">
              CUIT: NO REGISTRADO
            </p>
          </div>
          <div
            *ngIf="authService.loggedUser"
            class="option"
            [routerLink]="['profile']"
            routerLinkActive="active"
            (click)="showOptions = false; showMenuMobile = false"
          >
            <p>Mi perfil</p>
          </div>
          <div *ngIf="authService.loggedUser" class="option" (click)="authService.logout()">
            <p>Cerrar sesión</p>
          </div>
        </div>
      </div>
      <div class="menu">
        <div
          class="row"
          [routerLink]="authService.loggedUser ? ['/'] : ['/auth/signin']"
          [ngClass]="{ active: router.url === '/' && !isMarket }"
          (click)="showOptions = false; showMenuMobile = !showMenuMobile; isMarket = false"
        >
          <img class="small-image" src="/assets/icons/sidebar/Inicio.svg" alt="home" />
          <p>Dashboard</p>
        </div>

        <div class="row" [ngClass]="{ active: isMarket }" (click)="openAndCloseMarket()">
          <img class="small-image" src="/assets/icons/sidebar/market.svg" alt="exchange" />
          <p>Mercado</p>
          <img class="arrow-submenu" src="/assets/icons/sidebar/arrow-submenu.svg" alt="arrow" />
        </div>
        <ng-container *ngIf="isMarket">
          <div
            class="row"
            [routerLink]="['crypto-exchange']"
            [ngClass]="{ active: router.url.substring(0, 21).includes('/crypto-exchange') }"
            (click)="showMenuMobile = !showMenuMobile"
          >
            <div class="small-image"></div>
            <p
              class="text-market"
              [ngClass]="{ active: router.url.substring(0, 21).includes('/crypto-exchange') }"
            >
              Operación directa
            </p>
          </div>
          <div
            class="row"
            [routerLink]="['dca']"
            [ngClass]="{ active: router.url.substring(0, 21).includes('/dca') }"
            (click)="showMenuMobile = !showMenuMobile"
          >
            <div class="small-image"></div>
            <p
              class="text-market"
              [ngClass]="{ active: router.url.substring(0, 21).includes('/dca') }"
            >
              DCA
            </p>
          </div>
        </ng-container>
        <div
          class="row"
          [routerLink]="['canastas']"
          [ngClass]="{ active: router.url.substring(0, 21).includes('/canastas') }"
          (click)="showOptions = false; showMenuMobile = !showMenuMobile"
          *ngIf="!isCommerce && showBundle"
        >
          <img class="small-image" src="/assets/icons/sidebar/bundles.svg" alt="bundles" />
          <p>Canastas</p>
        </div>
        <div
          class="row"
          [routerLink]="['grupos']"
          [ngClass]="{ active: router.url.substring(0, 21).includes('/grupos') }"
          (click)="showOptions = false; showMenuMobile = !showMenuMobile"
          *ngIf="showJueguin"
        >
          <!-- Oculto hasta el lanzamiento -->
          <img class="small-image icon-group" src="/assets/icons/sidebar/group.svg" alt="group" />
          <p>Grupos</p>
          <span class="text-game">¡Jugá!</span>
        </div>

        <div
          class="row"
          [routerLink]="['swap']"
          [ngClass]="{ active: router.url.substring(0, 21).includes('/swap') }"
          (click)="showOptions = false; showMenuMobile = !showMenuMobile"
        >
          <img class="small-image" src="/assets/icons/sidebar/swap.svg" alt="swap" />
          <p>Swap</p>
        </div>

        <div
          class="row"
          [routerLink]="['history']"
          routerLinkActive="active"
          (click)="showOptions = false; showMenuMobile = !showMenuMobile; isMarket = false"
        >
          <img class="small-image" src="/assets/icons/sidebar/Historial.svg" alt="history" />
          <p>Historial</p>
        </div>

        <div
          class="row"
          *ngIf="isCompany"
          [routerLink]="['payroll']"
          [ngClass]="{ active: router.url.substring(0, 21).includes('/payroll') }"
          (click)="showOptions = false; showMenuMobile = !showMenuMobile"
        >
          <img class="small-image" src="/assets/icons/sidebar/payroll.svg" alt="payroll" />
          <p>Sueldos Crypto</p>
        </div>
      </div>
      <img class="logo-background" src="/assets/icons/logo_tc.png" alt="logo" />

      <div class="options">
        <div
          class="option page"
          *ngIf="isCommerce"
          [routerLink]="['commerce']"
          routerLinkActive="active"
          (click)="showOptions = false; showMenuMobile = !showMenuMobile; isMarket = false"
        >
          <img
            class="small-image"
            src="/assets/icons/sidebar/settings.svg"
            alt="commerce settings"
          />
          <p>Commerce</p>
        </div>
        <div class="option logout" (click)="authService.logout()">
          <img class="small-image" src="/assets/icons/sidebar/logout.svg" alt="logout" />
          <p>Salir</p>
        </div>
      </div>
      <div class="rights">
        <p>©{{ actualYear }} TiendaCrypto</p>
        <p>todos los derechos reservados</p>
      </div>
    </div>
  </div>
  <div class="center">
    <div class="header">
      <h2 class="main-title">{{ mainTitle }}</h2>
      <div class="userBtn-section">
        <button class="td-btn deposit-btn" (click)="openDialogDeposit()">Depositar</button>
        <button class="td-btn withdrawal-btn" (click)="openDialogWithdraw('')">Retirar</button>
        <button
          *ngIf="authService.loggedUser?.isCommerce"
          class="td-btn charge-btn"
          routerLink="/charge/"
        >
          Crear pago
          <img src="/assets/icons/lightning.svg" alt="lightning" />
        </button>
        <app-user-profile></app-user-profile>
      </div>
    </div>
    <div class="content">
      <div *ngIf="isMarketClosed" class="header-message">
        <app-reminder-message
          message="El mercado se encuentra cerrado temporalmente por lo que no se pueden realizar operaciones en este momento. Por favor, intentá más tarde."
          type="warning"
        >
        </app-reminder-message>
      </div>
      <div
        *ngIf="dataLayer?.alertMessages?.message && authService.loggedUser"
        class="header-message"
      >
        <app-reminder-message [message]="dataLayer?.alertMessages?.message" type="warning">
        </app-reminder-message>
      </div>

      <div
        *ngIf="
          authService?.loggedUser?.label === USER_LABEL.UNKNOWN_IDENTITY &&
          authService.loggedUser?.fundsDocuments?.selfie !== DOCUMENT_STATUS.PENDING
        "
        class="header-message"
      >
        <app-reminder-message
          message="Necesitamos validar su identidad, por favor, diríjase a <b>Mi Perfil > Identidad</b> para mas información."
          type="warning"
        >
        </app-reminder-message>
      </div>

      <div
        *ngIf="authService?.loggedUser?.label === USER_LABEL.REQUIRES_DOCUMENTATION"
        class="header-message"
      >
        <app-reminder-message
          message="Necesitamos que subas documentación que justifique tus operaciones."
          type="warning"
        >
        </app-reminder-message>
      </div>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<div class="dahsboard-loader" *ngIf="showDashboardLoader">
  <ng-lottie [options]="options"></ng-lottie>
</div>
